import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllCountries,
  createCountry,
  updateCountry,
  deleteCountry,
} from "../../redux/actions";
import { LoadingModal } from "../../components/modal/loading";
import {
  CreateCountryModal,
  EditCountryModal,
  DeleteConfirmModal,
} from "../../components/shipping/ShippingModals";

export const Country = () => {
  const dispatch = useDispatch();
  const { countries, loading } = useSelector((state) => state.shipping);

  const [createOpen, setCreateOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    dispatch(getAllCountries());
  }, [dispatch]);

  const handleCreate = (form) => {
    dispatch(createCountry(form));
    setCreateOpen(false);
  };

  const handleUpdate = (form) => {
    dispatch(updateCountry(selected.id, form));
    setEditOpen(false);
    setSelected(null);
  };

  const handleDelete = () => {
    dispatch(deleteCountry(selected.id));
    setDeleteOpen(false);
    setSelected(null);
  };

  return (
    <div className="space-y-6">
      {loading && <LoadingModal text="Loading..." />}

      <div className="flex items-center justify-between">
        <h1 className="text-lg font-semibold text-slate-900">Countries</h1>
        <button
          onClick={() => setCreateOpen(true)}
          className="rounded-xl bg-emerald-500 px-4 py-2 text-sm font-semibold text-white hover:bg-emerald-600"
        >
          Add Country
        </button>
      </div>

      <div className="rounded-2xl border border-slate-200 bg-white shadow-sm overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 border-b border-slate-200">
            <tr>
              <th className="px-4 py-3 text-left text-xs font-semibold text-slate-500 uppercase">
                #
              </th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-slate-500 uppercase">
                Name
              </th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-slate-500 uppercase">
                Code
              </th>
              <th className="px-4 py-3 text-right text-xs font-semibold text-slate-500 uppercase">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {countries.length === 0 ? (
              <tr>
                <td
                  colSpan={4}
                  className="px-4 py-8 text-center text-slate-400 text-sm"
                >
                  No countries found. Add one to get started.
                </td>
              </tr>
            ) : (
              countries.map((country, i) => (
                <tr key={country.id} className="hover:bg-slate-50 transition">
                  <td className="px-4 py-3 text-slate-500">{i + 1}</td>
                  <td className="px-4 py-3 font-medium text-slate-800">
                    {country.name}
                  </td>
                  <td className="px-4 py-3">
                    <span className="rounded-lg bg-slate-100 px-2 py-1 text-xs font-semibold text-slate-600">
                      {country.code}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-right space-x-2">
                    <button
                      onClick={() => {
                        setSelected(country);
                        setEditOpen(true);
                      }}
                      className="rounded-lg bg-slate-100 px-3 py-1 text-xs font-medium text-slate-700 hover:bg-slate-200"
                    >
                      Edit
                    </button>
                    <button
                      onClick={() => {
                        setSelected(country);
                        setDeleteOpen(true);
                      }}
                      className="rounded-lg bg-rose-50 px-3 py-1 text-xs font-medium text-rose-600 hover:bg-rose-100"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <CreateCountryModal
        open={createOpen}
        onClose={() => setCreateOpen(false)}
        onCreate={handleCreate}
      />
      <EditCountryModal
        open={editOpen}
        onClose={() => {
          setEditOpen(false);
          setSelected(null);
        }}
        onUpdate={handleUpdate}
        country={selected}
      />
      <DeleteConfirmModal
        open={deleteOpen}
        onClose={() => {
          setDeleteOpen(false);
          setSelected(null);
        }}
        onConfirm={handleDelete}
        title="Delete Country"
        message={`Are you sure you want to delete "${selected?.name}"? This action cannot be undone.`}
      />
    </div>
  );
};
